export enum DashboardItemType {
  NewOrder,
  OrdersBlotter,
  Inbox,
  InterventionBlotter,
  SalesScreen,
  TradesBlotter,
  Reporting,
  FindOrders,
  FindDeals,
  OrderAudit,
  OrderDetails,
  OrderModify,
  OrderModifyInfo,
  OrderDuplicate,
  OrderAmendMarkup,
  OrderBlotterAudit,
  OrderCancel,
  OrderTransfer,
  OrderTake,
  OrderForceTake,
  OrderFillNow,
  Export,
  OrderRecap,
  NotificationsViewer,
  ContactManager,
  ContactEdit,
  ClientTraderEdit,
  FilterManager,
  UserSettings,
  DealDetails,
  DetailFill,
  Divider,
  Header,
  HedgeOrderMonitor,
  OrdersLadder,
  OrderPauseResume,
  ScratchPad,
  BenchmarkSummary,
  ManualPricing,
  OpsIntBlotter,
  ConnectionMonitor,
  Admin,
  FwdRollPricing,
  ATDLDesigner,
  AlgoMonitor,
  RiskTradeBlotter,
}
